export default __webpack_public_path__ + "static/media/6.19b188e5.jpg";